import { render, staticRenderFns } from "./QuestionCategoryList.vue?vue&type=template&id=99d87fce&"
import script from "./QuestionCategoryList.vue?vue&type=script&lang=js&"
export * from "./QuestionCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports